// src/page/PanelAdministradorWrapper.jsx
import { useState } from "react";
import Login from "./Login";
import PanelAdministrador from "./PanelAdministrador";

export default function PanelAdministradorWrapper() {
  const [adminUser, setAdminUser] = useState(null);

  // Si no hay usuario → mostramos el login
  if (!adminUser) {
    return <Login setAdminUser={setAdminUser} />;
  }

  // Si hay usuario → mostramos el panel
  return <PanelAdministrador adminUser={adminUser} />;
}
